import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AuditLogs.css";
import { formatDateTime } from "../../utils/formatTimeDate";

const AuditLogs = () => {
    const [logs, setLogs] = useState([]);
    const [search, setSearch] = useState("");
    const [actionFilter, setActionFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchLogs(page);
    }, [page]);

    const fetchLogs = async (pageNum = 1) => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/admin/audit-logs?page=${pageNum}&limit=10`,
                { withCredentials: true }
            );

            setLogs(res.data.data);
            setTotalPages(res.data.totalPages);
            setPage(res.data.page);

        } catch (err) {
            console.error("Error fetching logs:", err);
        } finally {
            setLoading(false);
        }
    };

    const filteredLogs = logs.filter((log) => {
        return (
            (!actionFilter || log.action === actionFilter) &&
            (log.userId?.toLowerCase().includes(search.toLowerCase()) ||
                log.action?.toLowerCase().includes(search.toLowerCase()))
        );
    });

    const getDisplayName = (log) => {
        switch (log.action) {
            case "DELETE_USER":
                return log.details?.name || "-";

            case "DELETE_CHAT":
                return "Chat";

            case "RESET_PASSWORD":
                return log.details?.name || "-";

            case "UPDATE_USER_ROLE":
                return log.details?.name || "-";

            case "GENERATE_API_KEY":
                return log.details?.keyName || "API Key";

            case "INVITE_USER":
                return log.details?.name || "Invite";

            default:
                return "-";
        }
    };

    const getDisplayValue = (log) => {
        switch (log.action) {
            case "DELETE_USER":
                return log.details?.email || "-";

            case "UPDATE_USER_ROLE":
                return log.details?.email || "-";

            case "RESET_PASSWORD":
                return log.details?.email || "-";

            case "DELETE_CHAT":
                return log.details?.chatId || "-";

            case "GENERATE_API_KEY":
                return log.details?.key || "-";

            case "INVITE_USER":
                return log.details?.email || "-";

            default:
                return "-";
        }
    };

    return (
        <div className="audit-container">
            {/* Header */}
            <h2 className="audit-title">Audit Logs</h2>

            {/* Filters */}
            <div className="audit-filters">
                <input
                    type="text"
                    placeholder="Search by user or action..."
                    className="audit-input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <select
                    className="audit-select"
                    value={actionFilter}
                    onChange={(e) => setActionFilter(e.target.value)}
                >
                    <option value="">All Actions</option>
                    <option value="DELETE_USER">Delete User</option>
                    <option value="DELETE_CHAT">Delete Chat</option>
                    <option value="GENERATE_API_KEY">Generate Key</option>
                </select>
            </div>

            {/* Table */}
            <div className="audit-table-wrapper">
                <table className="audit-table">
                    <thead className="bg-gray-100 text-left">
                        <tr>
                            <th className="p-3">Action By</th>
                            <th className="p-3">Role</th>
                            <th className="p-3">Action</th>
                            <th className="p-3">User-Name</th>
                            <th className="p-3">User-Email</th>
                            <th className="p-3">Date/Time</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="p-4 text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : filteredLogs.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="p-4 text-center">
                                    No logs found
                                </td>
                            </tr>
                        ) : (
                            filteredLogs.map((log) => (
                                <tr key={log._id} className="border-t">
                                    <td className="p-3">{log.userName}</td>
                                    <td className="p-3">{log.role}</td>
                                    <td className="audit-action">
                                        <span className={`badge ${log.action}`}>
                                            {log.action}
                                        </span>
                                    </td>
                                    <td className="p-3">
                                        {getDisplayName(log)}
                                    </td>

                                    <td className="p-3 text-gray-600">
                                        {getDisplayValue(log)}
                                    </td>
                                    <td className="p-3">
                                        {formatDateTime(log.createdAt)}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <div className="pagination">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    <span>Page {page} of {totalPages}</span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuditLogs;